/**
 * Reusable active/enabled toggle section for rule configuration modals.
 */

import { ToggleSwitch } from "@risalabs_frontend_org/oasis-ui-kit";

interface ActiveToggleSectionProps {
  id: string;
  checked: boolean;
  onToggle: () => void;
  title?: string;
  description?: string;
}

/** Toggle row that controls whether a rule is active or disabled. */
const ActiveToggleSection = ({
  id,
  checked,
  onToggle,
  title = "Active Status",
  description = "If disabled, this rule will not be executed.",
}: ActiveToggleSectionProps) => (
  <div className="my-2 flex flex-row items-center justify-between gap-7 rounded-md border border-primaryGray-14 p-4">
    <div className="flex flex-col gap-1">
      <div className="text-sm">{title}</div>
      <div className="text-sm text-primaryGray-8">{description}</div>
    </div>
    <div>
      <ToggleSwitch id={id} defaultChecked={checked} onChangeEmit={onToggle} />
    </div>
  </div>
);

export default ActiveToggleSection;
